"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const openapi_1 = require("../../../../openapi");
const guard_1 = require("../guard");
const error_1 = require("../job/error");
const DeviceSchema = __importStar(require("../job/schema"));
const shared_1 = require("../shared");
const OtaJob = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V1.Admin.Device.OtaJob.Spec';
const MAX_LIST_PAGE_SIZE = 1000;
const OtaJobPageResponse = openapi_1.Response.Success(OtaJob.OtaJobPage).annotations({
    description: 'Paginated OTA jobs',
});
const OtaJobItemResponse = openapi_1.Response.Success(OtaJob.OtaJobItem).annotations({
    description: 'An OTA job, or null when the id belongs to a job of a different kind',
});
const OtaJobProgressPageResponse = openapi_1.Response.Success(OtaJob.OtaJobProgressPage).annotations({
    description: 'Paginated OTA job target progress',
});
const OtaJobToggleResponse = openapi_1.Response.Success(OtaJob.OtaJobToggleResult).annotations({
    description: 'The job after the toggle/restart',
});
const CreatedJobResponse = openapi_1.Response.Success(DeviceSchema.CreatedJob).annotations({
    description: 'The created/updated job id',
});
const OtaHistoryResponse = openapi_1.Response.Success(OtaJob.OtaHistory).annotations({
    description: 'OTA update history for a device',
});
// Query structs intentionally have no identifier (see shared.ts).
const ListQuery = effect_1.Schema.Struct({
    model: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Device model code',
    }),
    page: shared_1.page,
    pageSize: effect_1.Schema.optionalWith(shared_1.PositiveIntFromString.pipe(effect_1.Schema.lessThanOrEqualTo(MAX_LIST_PAGE_SIZE)), {
        exact: true,
    }).annotations({ description: 'Default 50.' }),
    size: effect_1.Schema.optionalWith(shared_1.PositiveIntFromString, { exact: true }).annotations({
        description: 'Validated but ignored on this endpoint; use pageSize.',
    }),
    orderBy: shared_1.orderBy,
    orderDir: shared_1.orderDir,
});
const ProgressQuery = effect_1.Schema.Struct({
    id: effect_1.Schema.NonEmptyString,
    page: shared_1.page,
    pageSize: effect_1.Schema.optionalWith(shared_1.PositiveIntFromString, { exact: true }).annotations({
        description: 'No declared maximum; silently clamped to 10000.',
    }),
    orderBy: shared_1.orderBy,
    orderDir: shared_1.orderDir,
});
const HistoryQuery = effect_1.Schema.Struct({
    id: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({
        description: 'Device ID (serial number).',
    }),
});
const listOtaJobs = platform_1.HttpApiEndpoint.get('listOtaJobs') `/ota/jobs/list`
    .setUrlParams(ListQuery)
    .addSuccess(OtaJobPageResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'List OTA Jobs')
    .annotate(platform_1.OpenApi.Description, 'Lists OTA jobs, optionally filtered by model. itemsCount may exceed items.length: command jobs sharing the collection are filtered out server-side after counting.')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const getOtaJob = platform_1.HttpApiEndpoint.get('getOtaJob') `/ota/job`
    .setUrlParams(effect_1.Schema.Struct({ id: effect_1.Schema.NonEmptyString }))
    .addSuccess(OtaJobItemResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Get OTA Job')
    .annotate(platform_1.OpenApi.Description, '404 when no job at all exists with this id; 200 { item: null } when the job exists but is a different kind (e.g. a command job).')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const getOtaJobProgress = platform_1.HttpApiEndpoint.get('getOtaJobProgress') `/ota/job/progress`
    .setUrlParams(ProgressQuery)
    .addSuccess(OtaJobProgressPageResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Get OTA Job Progress')
    .annotate(platform_1.OpenApi.Description, 'An unknown job id currently answers 500 (not 404).')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const createOtaJob = platform_1.HttpApiEndpoint.post('createOtaJob') `/ota/job`
    .setPayload(OtaJob.UpsertOtaJobPayload)
    .addSuccess(CreatedJobResponse, { status: 201 })
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Create OTA Job')
    .annotate(platform_1.OpenApi.Description, 'enabled defaults to false, trigger defaults to scheduler. An unknown buildFile currently answers 500 (the documented 422 INVALID_BUILD_FILE is unreachable).')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
const updateOtaJob = platform_1.HttpApiEndpoint.put('updateOtaJob') `/ota/job`
    .setPayload(OtaJob.UpdateOtaJobPayload)
    .addSuccess(CreatedJobResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Update OTA Job')
    .annotate(platform_1.OpenApi.Description, 'Full replacement, only while the job is queued or paused (403 CANNOT_EDIT_JOB otherwise). An unknown id currently answers 500 (not 404).')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
const toggleOtaJob = platform_1.HttpApiEndpoint.post('toggleOtaJob') `/ota/job/toggle`
    .setPayload(DeviceSchema.JobIdPayload)
    .addSuccess(OtaJobToggleResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(error_1.CannotToggleJob)
    .annotate(platform_1.OpenApi.Title, 'Toggle OTA Job')
    .annotate(platform_1.OpenApi.Description, 'Pauses an active job or resumes a paused one. 422 CANNOT_TOGGLE_JOB for canceled, completed or failed jobs.')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
const restartOtaJob = platform_1.HttpApiEndpoint.post('restartOtaJob') `/ota/job/restart`
    .setPayload(DeviceSchema.JobIdPayload)
    .addSuccess(OtaJobToggleResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(error_1.CannotRestartJob)
    .addError(error_1.CannotScheduleJob)
    .annotate(platform_1.OpenApi.Title, 'Restart OTA Job')
    .annotate(platform_1.OpenApi.Description, 'Allowed for coolDown, failed, waiting, queued, paused or canceled jobs (422 CANNOT_RESTART_JOB/CANNOT_SCHEDULE_JOB otherwise).')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
const cancelOtaJob = platform_1.HttpApiEndpoint.post('cancelOtaJob') `/ota/job/cancel`
    .setPayload(DeviceSchema.JobIdPayload)
    .addSuccess(openapi_1.Response.EmptyData)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(error_1.CannotCancelJob)
    .annotate(platform_1.OpenApi.Title, 'Cancel OTA Job')
    .annotate(platform_1.OpenApi.Description, 'Stops the job and keeps it with its history: the job is switched off, set to canceled, and its pending schedule is cancelled. A step that is running stops before its next batch. 422 CANNOT_CANCEL_JOB for canceled, completed or failed jobs.')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
const checkOtaJobCompletion = platform_1.HttpApiEndpoint.post('checkOtaJobCompletion') `/ota/job/check-completion`
    .addSuccess(openapi_1.Response.EmptyData)
    .annotate(platform_1.OpenApi.Title, 'Check OTA Job Completion')
    .annotate(platform_1.OpenApi.Description, 'Currently always answers 500: the route has no handler (otaJobController.checkCompletion does not exist).')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
const deleteOtaJob = platform_1.HttpApiEndpoint.del('deleteOtaJob') `/ota/job`
    .setUrlParams(effect_1.Schema.Struct({ id: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }) }))
    .setPayload(DeviceSchema.DeleteJobPayload)
    .addSuccess(openapi_1.Response.EmptyData)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Delete OTA Job')
    .annotate(platform_1.OpenApi.Description, 'Always deletes outright (never cancels), despite the name and JSDoc suggesting otherwise. id may be supplied via query or body (at least one is required); the body id wins when both are present. To stop a job and keep its history, cancel it instead.')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
const getOtaHistory = platform_1.HttpApiEndpoint.get('getOtaHistory') `/ota/history`
    .setUrlParams(HistoryQuery)
    .addSuccess(OtaHistoryResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Get OTA Update History')
    .annotate(platform_1.OpenApi.Description, 'OTA update history for a device, newest first. No pagination.')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
exports.Spec = platform_1.HttpApiGroup.make('v1.admin.device.ota-job')
    .add(listOtaJobs)
    .add(getOtaJob)
    .add(getOtaJobProgress)
    .add(createOtaJob)
    .add(updateOtaJob)
    .add(toggleOtaJob)
    .add(restartOtaJob)
    .add(cancelOtaJob)
    .add(checkOtaJobCompletion)
    .add(deleteOtaJob)
    .add(getOtaHistory)
    .prefix('/admin/device')
    .annotate(platform_1.OpenApi.Title, 'Device OTA Jobs')
    .annotate(platform_1.OpenApi.Description, 'Admin OTA update job endpoints')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Admin));
//# sourceMappingURL=spec.js.map